// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3MFcr","dragIcon":"SortableItem_dragIcon__3pFQH","disabled":"SortableItem_disabled__Htg7k"};